import * as React from "react";
import humanizeDuration from "humanize-duration";
import {FormFieldProps, Select} from "components/form";

const commandTimeoutsInSeconds = [30, 300, 900, 1800, 3600, 7200, 43200, 86400];

const commandTimeouts = commandTimeoutsInSeconds.map(t => {
    const h = Math.floor(t / 3600)
        .toString();
    const mm = Math.floor(t / 60 % 60)
        .toString()
        .padStart(2, "0");
    const ss = (t % 60)
        .toString()
        .padStart(2, "0");
    
    return {
        value: `${h}:${mm}:${ss}`,
        text: humanizeDuration(t * 1000, {units: ["h", "m", "s"]})
    };
});

const CommandTimeoutSelect: React.FC<FormFieldProps<string>> = props => (
    <Select value={props.value}
            onChange={props.onChange}
            items={commandTimeouts}
            fieldName="execution timeout"
    />
);

export default CommandTimeoutSelect;
